// test585
(585 && 0);
